// import { useState } from "react";
import { useEffect, useState, useContext, useRef } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

//  React components
import MDBox from "components/MDBox";
// import MDButton from "components/MDButton";

//  React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import FormField from "./components/FormField";
import { Autocomplete } from "@mui/material";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import { NavLink, useNavigate, useParams } from "react-router-dom";

import { v4 as uuidv4 } from "uuid";

const axios = require("axios").default;
import { DataContext } from "context/dataContext";
import ErrorText from "components/ErrorText";

const EditQuestion = () => {
  const params = useParams();

  const { dataState, getSingleQuestionApi, updateQuestionApi } = useContext(DataContext);
  const navigate = useNavigate();

  const [value, setValue] = useState({
    question: "",
    description: "",
  });

  const [errors, setErrors] = useState({
    question: "",
    description: "",
  });

  const uuidvNumbers = () => {
    const uuid = uuidv4();
    const uuidFinal = uuid.replace(/\D/g, "").slice(0, 12);
    return Number(uuidFinal);
  };

  const validateForm = () => {
    const newErrors = {
      question: value.question ? "" : "Question is required",
      description: value.description ? "" : "Description is required",
    };

    setErrors(newErrors);
    return Object.values(newErrors).every((error) => error === "");
  };

  const handleQuestion = (e) => {
    setValue({ ...value, question: e.target.value });
  };

  const handleDescription = (e) => {
    setValue({ ...value, description: e.target.value });
  };

  const ResetValue = () => {
    setValue({ ...value, question: "" });
    setValue({ ...value, description: "" });
  };

  const handleSubmit = (e) => {
    console.log("value", value);
    e.preventDefault();

    if (validateForm()) {
      var question_id = params.id;

      updateQuestionApi({
        id: question_id,
        question: value.question,
        description: value.description,
        created_on: new Date(),
      }).then((res) => {
        if (res.success) {
          console.log("Question updated");
          //window.location.refresh(false);
          navigate("/library/questions-list");
          ResetValue();
        } else {
          console.log("Something went wrong");
        }
      });
    }
  };

  // get old data from url
  useEffect(() => {
    let question_id = params.id;

    getSingleQuestionApi(question_id).then((res) => {
      if (res.success) {
        let resData = res?.data?.data?.journalquestion;
        console.log(resData);

        setValue({
          question: resData?.question || "",
          description: resData?.description || "",
        });
      } else {
        console.log("Something went wrong");
      }
    });
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={2} mb={2}>
        <Grid container justifyContent="center" alignItems="center" gap={2} sx={{ height: "100%" }}>
          <Grid item xs={12} lg={12}>
            <MDBox display="flex" alignItems="center" gap={2}>
              <MDButton
                variant="gradient"
                color="primary"
                component={NavLink}
                to="/library/question-list"
              >
                {" "}
                Go Back{" "}
              </MDButton>
            </MDBox>
          </Grid>
          <Grid item xs={12} lg={12}>
            <Card autoComplete="off" sx={{ height: "100%" }}>
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                gap={1}
                sx={{ height: "100%" }}
              >
                <Grid item xs={12} sm={12} p={3} pb={0}>
                  <MDTypography variant="h5">Edit - Question</MDTypography>
                </Grid>
                <Grid item xs={12} sm={12} pb={2} p={3}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={12}>
                      <FormField
                        type="text"
                        value={value.question}
                        onChange={handleQuestion}
                        label="Question"
                      />
                      {errors.question && <ErrorText errorName={errors.question} />}
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <FormField
                        type="text"
                        multiline
                        rows={2}
                        label="Description"
                        value={value.description}
                        onChange={handleDescription}
                      />
                      {errors.description && <ErrorText errorName={errors.description} />}
                    </Grid>

                    <Grid item xs={12}>
                      <MDButton variant="gradient" color="primary" onClick={handleSubmit}>
                        Save Question
                      </MDButton>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {/* <Footer /> */}
    </DashboardLayout>
  );
};

export default EditQuestion;
